// extracted by mini-css-extract-plugin
export var logo = "_66-2";
export var logoWrapper = "_66-1";
export var strip = "_66-0";